/* Steep accessibility hardening — staged 2026-08-23 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const applyMotionPreference = () => {
    if (!reducedMotion.matches) return;
    document.querySelectorAll('video[autoplay]').forEach((video) => {
      video.pause();
      video.removeAttribute('autoplay');
    });
  };

  const hasAccessibleName = (element) => {
    const labelledBy = element.getAttribute('aria-labelledby');
    const labelledByText = labelledBy
      ? labelledBy.split(/\s+/).map((id) => document.getElementById(id)?.textContent || '').join(' ').trim()
      : '';
    return Boolean(
      element.getAttribute('aria-label')?.trim() ||
      labelledByText ||
      element.getAttribute('title')?.trim() ||
      element.textContent?.trim() ||
      element.querySelector('img[alt]:not([alt=""])')?.getAttribute('alt')?.trim()
    );
  };

  const productNameFromLink = (link) => {
    const imageAlt = link.querySelector('img[alt]:not([alt=""])')?.getAttribute('alt')?.trim();
    if (imageAlt) return imageAlt;
    const path = new URL(link.href, window.location.origin).pathname;
    if (path === '/products/steep-original-ginger-citrus') return 'Steep Original Ginger Citrus';
    return 'product details';
  };

  const repairDuplicateContactFormIds = () => {
    document.querySelectorAll('form#contact_form').forEach((form, index) => {
      if (index === 0) return;
      const nextId = `contact_form-${index + 1}`;
      form.id = nextId;
      form.querySelectorAll('[for="contact_form"]').forEach((label) => label.setAttribute('for', nextId));
    });
  };

  const applyAccessibleNames = () => {
    document.querySelectorAll('a.header-logo').forEach((link) => {
      if (!hasAccessibleName(link)) link.setAttribute('aria-label', 'Steep Yerba Mate Energy home');
    });

    document.querySelectorAll('a.group-block__link, a.media-block__media-link, a[class*="ai-image-hover-wrapper"]').forEach((link) => {
      if (!hasAccessibleName(link)) link.setAttribute('aria-label', `View ${productNameFromLink(link)}`);
    });

    document.querySelectorAll('slideshow-slides[tabindex="-1"]').forEach((scroller) => {
      if (scroller.scrollWidth > scroller.clientWidth + 1 || scroller.scrollHeight > scroller.clientHeight + 1) scroller.setAttribute('tabindex', '0');
    });
    repairDuplicateContactFormIds();
  };

  let enhancementFrame = 0;
  const scheduleEnhancements = () => {
    if (enhancementFrame) return;
    enhancementFrame = window.requestAnimationFrame(() => {
      enhancementFrame = 0;
      applyMotionPreference();
      applyAccessibleNames();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhancements, { once: true });
  } else {
    scheduleEnhancements();
  }

  reducedMotion.addEventListener?.('change', scheduleEnhancements);
  document.addEventListener('shopify:section:load', scheduleEnhancements);
  new MutationObserver(scheduleEnhancements).observe(document.documentElement, { childList: true, subtree: true });
})();

